import Flickity from "flickity";

class HomepageCarousel {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
		self.carousel = self.elem.querySelector('.js-flickity-carousel');
	}

	init() {
		let self = this;

		if(self.getWindowWidth() >= 860) {
			self.flkty = new Flickity( self.carousel, {
				// options
				lazyLoad: true,
				cellAlign: 'left',
				contain: true,
				autoPlay: 4000,
				pauseAutoPlayOnHover: false,
				draggable: false
			});
		} else {
			self.flkty = new Flickity( self.carousel, {
				// options
				lazyLoad: true,
				cellAlign: 'left',
				contain: true,
				draggable: false
			});
		}


		self.viewPort = self.elem.querySelector('.flickity-viewport');

		window.addEventListener("resize", () => {
			self.flkty.resize();
			self.viewPort.style.height = null;
		});
	}

	getWindowWidth() {
		return window.innerWidth || document.documentElement.clientWidth;
	}
}

export default HomepageCarousel;